import { render } from "./TaskGroup.vue?vue&type=template&id=cf9a063a&scoped=true"
import script from "./TaskGroup.vue?vue&type=script&lang=js"
export * from "./TaskGroup.vue?vue&type=script&lang=js"

import "./TaskGroup.vue?vue&type=style&index=0&id=cf9a063a&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf9a063a"]])

export default __exports__